(function () {
  'use strict';

  // ─── VARIANT MAP ──────────────────────────────────────────────────────────
  var VARIANT_MAP = {
    'Duo|2 Rigide 20x20|Avec':                                          '56265330917755',
    'Duo|2 Rigide 20x20|Sans':                                          '56265330950523',
    'Duo|1 Rigide 20x20 + 1 Souple 14x14|Avec':                        '56265330983291',
    'Duo|1 Rigide 20x20 + 1 Souple 14x14|Sans':                        '56265331016059',
    'Duo|1 Rigide 20x20 + 1 Souple 20x20|Avec':                        '56265331048827',
    'Duo|1 Rigide 20x20 + 1 Souple 20x20|Sans':                        '56265331081595',
    'Duo|2 Souple 14x14|Avec':                                          '56265331114363',
    'Duo|2 Souple 14x14|Sans':                                          '56265331147131',
    'Duo|1 Souple 14x14 + 1 Souple 20x20|Avec':                        '56265331179899',
    'Duo|1 Souple 14x14 + 1 Souple 20x20|Sans':                        '56265331212667',
    'Duo|2 Souple 20x20|Avec':                                          '56265331245435',
    'Duo|2 Souple 20x20|Sans':                                          '56265331278203',
    'Trio|3 Rigide 20x20|Avec':                                         '56265331310971',
    'Trio|3 Rigide 20x20|Sans':                                         '56265331343739',
    'Trio|2 Rigide 20x20 + 1 Souple 14x14|Avec':                       '56265331376507',
    'Trio|2 Rigide 20x20 + 1 Souple 14x14|Sans':                       '56265331409275',
    'Trio|2 Rigide 20x20 + 1 Souple 20x20|Avec':                       '56265331442043',
    'Trio|2 Rigide 20x20 + 1 Souple 20x20|Sans':                       '56265331474811',
    'Trio|1 Rigide 20x20 + 2 Souple 14x14|Avec':                       '56265331507579',
    'Trio|1 Rigide 20x20 + 2 Souple 14x14|Sans':                       '56265331540347',
    'Trio|1 Rigide 20x20 + 1 Souple 14x14 + 1 Souple 20x20|Avec':     '56265331573115',
    'Trio|1 Rigide 20x20 + 1 Souple 14x14 + 1 Souple 20x20|Sans':     '56265331605883',
    'Trio|1 Rigide 20x20 + 2 Souple 20x20|Avec':                       '56265331638651',
    'Trio|1 Rigide 20x20 + 2 Souple 20x20|Sans':                       '56265331671419',
    'Trio|3 Souple 14x14|Avec':                                         '56265331704187',
    'Trio|3 Souple 14x14|Sans':                                         '56265331736955',
    'Trio|2 Souple 14x14 + 1 Souple 20x20|Avec':                       '56265331769723',
    'Trio|2 Souple 14x14 + 1 Souple 20x20|Sans':                       '56265331802491',
    'Trio|1 Souple 14x14 + 2 Souple 20x20|Avec':                       '56265331835259',
    'Trio|1 Souple 14x14 + 2 Souple 20x20|Sans':                       '56265331868027',
    'Trio|3 Souple 20x20|Avec':                                         '56265331900795',
    'Trio|3 Souple 20x20|Sans':                                         '56265331933563',
    'Familial|4 Rigide 20x20|Avec':                                     '56265331966331',
    'Familial|4 Rigide 20x20|Sans':                                     '56265331999099',
    'Familial|3 Rigide 20x20 + 1 Souple 14x14|Avec':                   '56265332031867',
    'Familial|3 Rigide 20x20 + 1 Souple 14x14|Sans':                   '56265332064635',
    'Familial|3 Rigide 20x20 + 1 Souple 20x20|Avec':                   '56265332097403',
    'Familial|3 Rigide 20x20 + 1 Souple 20x20|Sans':                   '56265332130171',
    'Familial|2 Rigide 20x20 + 2 Souple 14x14|Avec':                   '56265332162939',
    'Familial|2 Rigide 20x20 + 2 Souple 14x14|Sans':                   '56265332195707',
    'Familial|2 Rigide 20x20 + 1 Souple 14x14 + 1 Souple 20x20|Avec': '56265332228475',
    'Familial|2 Rigide 20x20 + 1 Souple 14x14 + 1 Souple 20x20|Sans': '56265332261243',
    'Familial|2 Rigide 20x20 + 2 Souple 20x20|Avec':                   '56265332294011',
    'Familial|2 Rigide 20x20 + 2 Souple 20x20|Sans':                   '56265332326779',
    'Familial|1 Rigide 20x20 + 3 Souple 14x14|Avec':                   '56265332359547',
    'Familial|1 Rigide 20x20 + 3 Souple 14x14|Sans':                   '56265332392315',
    'Familial|1 Rigide 20x20 + 2 Souple 14x14 + 1 Souple 20x20|Avec': '56265332425083',
    'Familial|1 Rigide 20x20 + 2 Souple 14x14 + 1 Souple 20x20|Sans': '56265332457851',
    'Familial|1 Rigide 20x20 + 1 Souple 14x14 + 2 Souple 20x20|Avec': '56265332490619',
    'Familial|1 Rigide 20x20 + 1 Souple 14x14 + 2 Souple 20x20|Sans': '56265332523387',
    'Familial|1 Rigide 20x20 + 3 Souple 20x20|Avec':                   '56265332556155',
    'Familial|1 Rigide 20x20 + 3 Souple 20x20|Sans':                   '56265332588923',
    'Familial|4 Souple 14x14|Avec':                                     '56265332621691',
    'Familial|4 Souple 14x14|Sans':                                     '56265332654459',
    'Familial|3 Souple 14x14 + 1 Souple 20x20|Avec':                   '56265332687227',
    'Familial|3 Souple 14x14 + 1 Souple 20x20|Sans':                   '56265332719995',
    'Familial|2 Souple 14x14 + 2 Souple 20x20|Avec':                   '56265332752763',
    'Familial|2 Souple 14x14 + 2 Souple 20x20|Sans':                   '56265332785531',
    'Familial|1 Souple 14x14 + 3 Souple 20x20|Avec':                   '56265332818299',
    'Familial|1 Souple 14x14 + 3 Souple 20x20|Sans':                   '56265332851067',
    'Familial|4 Souple 20x20|Avec':                                     '56265332883835',
    'Familial|4 Souple 20x20|Sans':                                     '56265332916603'
  };

  var PACK_BOOK_COUNTS = { Duo: 2, Trio: 3, Familial: 4 };

  var CATEGORIES_BOY = [
    { id: 'skin',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview-2.png?v=1779365649' },
    { id: 'hair',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview.png?v=1779365608' },
    { id: 'accessories', img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview_315649bd-d3c0-4590-b486-0862e518dc58.png?v=1779365622' },
    { id: 'glasses',     img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/6-removebg-preview.png?v=1779365640' },
    { id: 'freckles',    img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview-3.png?v=1779365660' },
    { id: 'eyes',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/truc-removebg-preview.png?v=1779365669' }
  ];
  var CATEGORIES_GIRL = [
    { id: 'outfit',      img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Capture_d_ecran_2026-04-08_a_21.54.13.png?v=1782942884', imgSize: '28px' },
    { id: 'skin',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview-2.png?v=1779365649' },
    { id: 'hair',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview.png?v=1779365608' },
    { id: 'accessories', img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview_315649bd-d3c0-4590-b486-0862e518dc58.png?v=1779365622' },
    { id: 'glasses',     img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/6-removebg-preview.png?v=1779365640' },
    { id: 'freckles',    img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/5-removebg-preview-3.png?v=1779365660' },
    { id: 'eyes',        img: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/truc-removebg-preview.png?v=1779365669' }
  ];
  function getCategories(gender) { return gender === 'girl' ? CATEGORIES_GIRL : CATEGORIES_BOY; }

  // ─── STATE ────────────────────────────────────────────────────────────────
  var state = {
    pack:              null,
    currentBookIndex:  0,
    isSecondaryChar:   false,
    booksData:         [],
    currentStep:       'pbStepPack'
  };
  var pickerPrimaryChar   = null;  // null = new char, or saved char object
  var pickerSecondaryChar = null;  // null = none, 'new' = new char, or saved char object
  var pickerActive        = false;
  var pickerSkippedChar   = false; // true when pbStepChar was skipped via picker
  var secondaryAfterCover = false; // true when pbStepSecondary appears after cover (book 0)
  var secondaryReproposed = false; // true when pbStepSecondary re-proposed after primary info (book 1+)

  function createDefaultCharState() {
    return {
      gender:         'boy',
      category:       'skin',
      hairIdx:        0,
      savedHairIdx:   -1,
      hairColorIdx:   0,
      accessoriesIdx: 0,
      glassesIdx:     0,
      skinIdx:        0,
      frecklesIdx:    0,
      eyesIdx:        0,
      outfitIdx:      0,
      prenom:         '',
      age:            '',
      reves:          '',
      anecdotes:      '',
      dedicace:       '',
      lien:           '',
      imageUrl:       ''
    };
  }

  // Renvoie l'index de coupe autorisé le plus proche de idx (ou idx s'il est déjà autorisé).
  // Priorité à une coupe de même longueur (long/court) que la coupe d'origine, pour éviter
  // qu'un cheveux long soit remplacé par un court (ou l'inverse) en mettant un couvre-chef.
  function nearestAllowedHair(idx, allowed, hairStyles) {
    if (!allowed || !allowed.length) return idx;
    if (allowed.indexOf(idx) !== -1) return idx;
    function closest(list) {
      return list.reduce(function(best, a) {
        return Math.abs(a - idx) < Math.abs(best - idx) ? a : best;
      }, list[0]);
    }
    if (hairStyles && hairStyles[idx] && hairStyles[idx].length) {
      var wantedLength = hairStyles[idx].length;
      var sameLength = allowed.filter(function(a) {
        return hairStyles[a] && hairStyles[a].length === wantedLength;
      });
      if (sameLength.length) return closest(sameLength);
    }
    return closest(allowed);
  }

  // Une coupe est bloquée si un couvre-chef actif ne l'autorise pas dans sa liste allowedHair
  function isHairBlocked(idx) {
    if (charState.accessoriesIdx <= 0) return false;
    var opts = getAccessoriesOpts(charState.gender);
    var opt  = opts ? opts[charState.accessoriesIdx] : null;
    if (!opt) return false;
    if (opt.hideHair) return true;
    return !!(opt.allowedHair && opt.allowedHair.length && opt.allowedHair.indexOf(idx) === -1);
  }

  var _prevAccessoriesIdx = -1; // détecte un changement réel d'accessoire (pour ne snapper qu'une fois)

  // Applique la logique de compatibilité coupe/couvre-chef quand l'accessoire change
  function applyHeadwearLogic() {
    var opts = getAccessoriesOpts(charState.gender);
    var opt  = opts ? opts[charState.accessoriesIdx] : null;
    var justChanged = _prevAccessoriesIdx !== charState.accessoriesIdx;
    if (charState.accessoriesIdx > 0 && opt) {
      if (charState.savedHairIdx < 0) charState.savedHairIdx = charState.hairIdx;
      if (opt.hideHair) {
        // rien à faire ici, le rendu masque la couche cheveux (voir renderCanvas)
      } else if (justChanged && opt.allowedHair && opt.allowedHair.length) {
        charState.hairIdx = nearestAllowedHair(charState.savedHairIdx, opt.allowedHair, getHairStyles(charState.gender));
      } else if (justChanged) {
        var hairOpts = getHairStyles(charState.gender);
        var buzzIdx = hairOpts ? hairOpts.findIndex(function(s){ return s.id === 'buzz'; }) : -1;
        if (buzzIdx !== -1) charState.hairIdx = buzzIdx;
      }
    } else if (charState.savedHairIdx >= 0) {
      charState.hairIdx = charState.savedHairIdx;
      charState.savedHairIdx = -1;
    }
    _prevAccessoriesIdx = charState.accessoriesIdx;
  }

  var charState = createDefaultCharState();

  // ─── IMAGE PRELOADER ─────────────────────────────────────────────────────
  var _preloadCache = [];
  function preloadImages() {
    var urls = [];
    function addUrl(u) { if (u && u.indexOf('URL_') === -1 && u !== '') urls.push(u); }
    function addOpt(opt) {
      if (!opt) return;
      if (opt.url) addUrl(opt.url);
      if (opt.colors) {
        Object.keys(opt.colors).forEach(function(k) {
          if (opt.colors[k] && opt.colors[k].url) addUrl(opt.colors[k].url);
        });
      }
    }
    function addList(arr) { if (arr) arr.forEach(addOpt); }
    addList(typeof SKIN_TONES !== 'undefined' ? SKIN_TONES : null);
    addList(typeof SKIN_TONES_GIRL !== 'undefined' ? SKIN_TONES_GIRL : null);
    addList(typeof HAIR_STYLES_BOY !== 'undefined' ? HAIR_STYLES_BOY : null);
    addList(typeof HAIR_STYLES_GIRL !== 'undefined' ? HAIR_STYLES_GIRL : null);
    addList(typeof EYEBROWS_OPTIONS !== 'undefined' ? EYEBROWS_OPTIONS : null);
    addList(typeof EYEBROWS_OPTIONS_GIRL !== 'undefined' ? EYEBROWS_OPTIONS_GIRL : null);
    addList(typeof EYES_OPTIONS !== 'undefined' ? EYES_OPTIONS : null);
    addList(typeof GLASSES_OPTIONS !== 'undefined' ? GLASSES_OPTIONS : null);
    addList(typeof FRECKLES_OPTIONS !== 'undefined' ? FRECKLES_OPTIONS : null);
    addList(typeof ACCESSORIES_OPTIONS !== 'undefined' ? ACCESSORIES_OPTIONS : null);
    addList(typeof ACCESSORIES_OPTIONS_GIRL !== 'undefined' ? ACCESSORIES_OPTIONS_GIRL : null);
    var seen = {};
    urls.forEach(function(url) {
      if (seen[url]) return;
      seen[url] = true;
      var img = new Image();
      img.src = url;
      _preloadCache.push(img);
    });
  }

  // ─── CLOUDINARY IMAGE CAPTURE ────────────────────────────────────────────
  var CLOUDINARY_CLOUD_NAME    = 'daevhiitx';
  var CLOUDINARY_UPLOAD_PRESET = 'livre_perso';

  function parseComputedMatrix(matrixStr) {
    if (!matrixStr || matrixStr === 'none') return { scaleX: 1, scaleY: 1 };
    var vals = matrixStr.match(/matrix.*\((.+)\)/);
    if (!vals) return { scaleX: 1, scaleY: 1 };
    var parts = vals[1].split(',').map(function (v) { return parseFloat(v.trim()); });
    return { scaleX: parts[0] || 1, scaleY: parts[3] || 1 };
  }

  function loadImgCrossOrigin(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = url;
    });
  }

  async function capturePackCharacter() {
    var layerIds = [
      'pbBaseLayer', 'pbSkinLayer', 'pbFrecklesLayer',
      'pbEyesLayer', 'pbEyebrowsLayer', 'pbHairLayer',
      'pbGlassesLayer', 'pbAccessoriesLayer'
    ];

    var baseEl = document.getElementById('pbBaseLayer');
    if (!baseEl) return null;

    var container = baseEl.parentElement;
    while (container && !container.classList.contains('character-canvas')) {
      container = container.parentElement;
    }
    if (!container) return null;

    var containerRect = container.getBoundingClientRect();
    var layers = [];

    layerIds.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.src || el.style.display === 'none') return;
      var computed = window.getComputedStyle(el);
      var rect = el.getBoundingClientRect();
      layers.push({
        url:          el.src,
        x:            rect.left - containerRect.left,
        y:            rect.top  - containerRect.top,
        displayWidth: rect.width,
        displayHeight:rect.height
      });
    });

    if (!layers.length) return null;

    var loadedLayers = [];
    for (var i = 0; i < layers.length; i++) {
      try {
        var img = await loadImgCrossOrigin(layers[i].url);
        loadedLayers.push({ img: img, layer: layers[i] });
      } catch (e) {}
    }
    if (!loadedLayers.length) return null;

    var minX = 0, minY = 0, maxX = containerRect.width, maxY = containerRect.height;
    loadedLayers.forEach(function (ll) {
      var l = ll.layer;
      minX = Math.min(minX, l.x);
      minY = Math.min(minY, l.y);
      maxX = Math.max(maxX, l.x + l.displayWidth);
      maxY = Math.max(maxY, l.y + l.displayHeight);
    });

    var canvas = document.createElement('canvas');
    canvas.width  = Math.ceil(maxX - minX);
    canvas.height = Math.ceil(maxY - minY);
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    loadedLayers.forEach(function (ll) {
      var l = ll.layer, img = ll.img;
      var scale = Math.min(l.displayWidth / img.naturalWidth, l.displayHeight / img.naturalHeight);
      var fw = img.naturalWidth  * scale;
      var fh = img.naturalHeight * scale;
      var ox = (l.displayWidth  - fw) / 2;
      var oy = (l.displayHeight - fh) / 2;
      ctx.drawImage(img, l.x - minX + ox, l.y - minY + oy, fw, fh);
    });

    var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png', 0.95); });

    var formData = new FormData();
    formData.append('file', blob);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    var response = await fetch(
      'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD_NAME + '/image/upload',
      { method: 'POST', body: formData }
    );
    var data = await response.json();
    return data.secure_url || null;
  }

  // ─── DATA ACCESSORS ───────────────────────────────────────────────────────
  function getHairStyles(gender) {
    return gender === 'girl' ? HAIR_STYLES_GIRL : HAIR_STYLES_BOY;
  }
  function getSkinTones(gender)       { return gender === 'girl' ? SKIN_TONES_GIRL        : SKIN_TONES;             }
  function getEyebrowsOpts(gender)    { return gender === 'girl' ? EYEBROWS_OPTIONS_GIRL  : EYEBROWS_OPTIONS;       }
  function getAccessoriesOpts(gender) { return gender === 'girl' ? ACCESSORIES_OPTIONS_GIRL : ACCESSORIES_OPTIONS;  }

  function getOptions(cat, gender) {
    var opts;
    if (cat === 'hair')             opts = getHairStyles(gender);
    else if (cat === 'accessories') opts = getAccessoriesOpts(gender);
    else if (cat === 'glasses')     opts = GLASSES_OPTIONS;
    else if (cat === 'skin')        opts = getSkinTones(gender);
    else if (cat === 'freckles')    opts = FRECKLES_OPTIONS;
    else if (cat === 'eyes')        opts = EYES_OPTIONS;
    else if (cat === 'outfit')      opts = [
      { id: 'robe', name: 'Robe', url: (typeof SKIN_TONES_GIRL !== 'undefined' && SKIN_TONES_GIRL[charState.skinIdx]) ? SKIN_TONES_GIRL[charState.skinIdx].url : '' },
      { id: 'jean', name: 'Jean', url: (typeof SKIN_TONES_GIRL_JEAN !== 'undefined' && SKIN_TONES_GIRL_JEAN[charState.skinIdx]) ? SKIN_TONES_GIRL_JEAN[charState.skinIdx].url : '' }
    ];
    else opts = [];
    if (cat === 'accessories' || cat === 'glasses' || cat === 'freckles' || cat === 'outfit') return opts;
    return opts.filter(function (o) { return o.id !== 'none'; });
  }

  function getCatIdx() {
    var c = charState.category;
    if (c === 'hair')        return charState.hairIdx;
    if (c === 'accessories') return charState.accessoriesIdx;
    if (c === 'glasses')     return charState.glassesIdx;
    if (c === 'skin')        return charState.skinIdx;
    if (c === 'freckles')    return charState.frecklesIdx;
    if (c === 'eyes')        return charState.eyesIdx;
    if (c === 'outfit')      return charState.outfitIdx;
    return 0;
  }

  function setCatIdx(val) {
    var c = charState.category;
    if (c === 'hair')             charState.hairIdx        = val;
    else if (c === 'accessories') charState.accessoriesIdx = val;
    else if (c === 'glasses')     charState.glassesIdx     = val;
    else if (c === 'skin')        charState.skinIdx        = val;
    else if (c === 'freckles')    charState.frecklesIdx    = val;
    else if (c === 'eyes')        charState.eyesIdx        = val;
    else if (c === 'outfit')      charState.outfitIdx      = val;
  }

  // ─── CHARACTER UI RENDER ──────────────────────────────────────────────────
  function renderCharUI() {
    renderCategoryBtns();
    renderVariantOpts();
    renderColorOpts();
    renderCanvas();
    updateCatLabel();
    updateGenderBtns();
    updateFormTitle();
    updateFormFields();
  }

  var _catSwipeX = null;

  function renderCategoryBtns(forceRebuild) {
    var container = document.getElementById('pbCategoryList');
    if (!container) return;

    var cats = getCategories(charState.gender);

    // Ne reconstruire le DOM que si la liste de catégories a changé (ex: changement de genre).
    // Sinon on se contente de mettre à jour l'état actif — évite de re-déclencher le
    // MutationObserver du carrousel (et donc un re-scroll/glitch visuel) à chaque
    // sélection de coiffure/accessoire.
    var existing = Array.from(container.children);
    var sameSet = !forceRebuild && existing.length === cats.length &&
      existing.every(function (b, i) { return b._catId === cats[i].id; });

    if (sameSet) {
      existing.forEach(function (btn) {
        var isSelected = btn._catId === charState.category;
        btn.className = 'compact-category-btn' + (isSelected ? ' active' : '');
        btn.style.border = isSelected ? '2px solid #C1E5F1' : '2px solid #E5E5E5';
        btn.style.boxShadow = isSelected ? '0 2px 8px rgba(193,229,241,0.3)' : 'none';
      });
      return;
    }

    container.innerHTML = '';

    var cur = 0;
    for (var k = 0; k < cats.length; k++) {
      if (cats[k].id === charState.category) { cur = k; break; }
    }

    for (var i = 0; i < cats.length; i++) {
      var cat        = cats[i];
      var isSelected = i === cur;
      var btn        = document.createElement('button');
      btn._catId     = cat.id;
      btn.className = 'compact-category-btn' + (isSelected ? ' active' : '');
      btn.style.cssText = 'width:42px;height:42px;border-radius:8px;background:white;border:2px solid ' + (isSelected ? '#C1E5F1' : '#E5E5E5') + ';cursor:pointer;transition:all 0.2s;display:flex;align-items:center;justify-content:center;overflow:hidden;' + (isSelected ? 'box-shadow:0 2px 8px rgba(193,229,241,0.3);' : '');
      var img        = document.createElement('img');
      img.src        = cat.img;
      var imgSize    = cat.imgSize || '85px';
      img.style.cssText = 'width:' + imgSize + ';height:' + imgSize + ';object-fit:contain;';
      img.alt        = '';
      btn.appendChild(img);
      (function (catId) {
        btn.onclick = function () { charState.category = catId; renderCharUI(); };
      })(cat.id);
      container.appendChild(btn);
    }

    if (!container._swipeReady) {
      container._swipeReady = true;
      container.addEventListener('touchstart', function (e) {
        _catSwipeX = e.touches[0].clientX;
      }, { passive: true });
      container.addEventListener('touchend', function (e) {
        if (_catSwipeX === null) return;
        var dx = e.changedTouches[0].clientX - _catSwipeX;
        _catSwipeX = null;
        if (Math.abs(dx) < 20) return;
        var ids = getCategories(charState.gender).map(function (c) { return c.id; });
        var idx = ids.indexOf(charState.category);
        if (dx < 0 && idx < ids.length - 1) { charState.category = ids[idx + 1]; renderCharUI(); }
        else if (dx > 0 && idx > 0)          { charState.category = ids[idx - 1]; renderCharUI(); }
      }, { passive: true });
    }
  }

  function _applyOptIcon(btn, opt, cat) {
    if (opt.icon) {
      btn.textContent = opt.icon;
    } else if ((cat === 'skin' || cat === 'eyes') && opt.color) {
      btn.style.background = opt.color;
    } else if (cat === 'hair' && (opt.icon_url || opt.colors)) {
      var colorId   = HAIR_COLORS[charState.hairColorIdx] ? HAIR_COLORS[charState.hairColorIdx].id : null;
      var colorData = opt.colors && colorId ? opt.colors[colorId] : null;
      var url       = opt.icon_url || (colorData ? colorData.url : null);
      if (url && url.indexOf('URL_') === -1) {
        btn.style.backgroundImage    = 'url(' + url + ')';
        btn.style.backgroundSize     = '70% 70%';
        btn.style.backgroundRepeat   = 'no-repeat';
        btn.style.backgroundPosition = 'center';
      } else {
        btn.textContent = (opt.name || '?').charAt(0).toUpperCase();
      }
    } else if (opt.icon_url) {
      btn.style.backgroundImage    = 'url(' + opt.icon_url + ')';
      btn.style.backgroundSize     = '70% 70%';
      btn.style.backgroundRepeat   = 'no-repeat';
      btn.style.backgroundPosition = 'center';
    } else if (opt.url) {
      btn.style.backgroundImage    = 'url(' + opt.url + ')';
      btn.style.backgroundSize     = 'contain';
      btn.style.backgroundRepeat   = 'no-repeat';
      btn.style.backgroundPosition = 'center';
    } else {
      btn.textContent = (opt.name || '?').charAt(0).toUpperCase();
    }
  }

  function _scrollCenter(container, cur, halfBtn, smooth) {
    var contW   = container.offsetWidth || 320;
    var sidePad = Math.max(0, Math.floor(contW / 2) - halfBtn);
    container.style.paddingLeft  = sidePad + 'px';
    container.style.paddingRight = sidePad + 'px';
    var target = cur * 48;
    requestAnimationFrame(function () {
      if (smooth) { container.scrollTo({ left: target, behavior: 'smooth' }); }
      else        { container.scrollLeft = target; }
    });
  }

  function renderVariantOpts() {
    var container = document.getElementById('pbVariantOptions');
    if (!container) return;

    var opts = getOptions(charState.category, charState.gender);
    var cur  = getCatIdx();

    // Ne reconstruire le DOM que si la liste d'options a changé (catégorie/genre différent).
    // Sinon on met juste à jour l'état sélectionné/bloqué + l'icône (couleur de cheveux) sur les
    // boutons existants — reconstruire à chaque clic redéclenchait le MutationObserver du
    // carrousel à chaque sélection, l'empêchant de se stabiliser centré sur le choix actif.
    var key = charState.category + '|' + charState.gender + '|' + opts.length;
    var existing = Array.from(container.children);
    var sameSet = container._optsKey === key && existing.length === opts.length;

    if (sameSet) {
      existing.forEach(function (btn, i) {
        var opt        = opts[i];
        var isSelected = i === cur;
        var blocked    = charState.category === 'hair' && isHairBlocked(i);
        btn.style.transform  = 'scale(' + (isSelected ? 1.1 : 1) + ')';
        btn.style.boxShadow  = isSelected
          ? 'inset 0 0 0 3px #C1E5F1,0 2px 8px rgba(193,229,241,0.5)'
          : 'inset 0 0 0 2px #E5E5E5';
        btn.style.opacity  = blocked ? '0.3' : '1';
        btn.style.cursor   = blocked ? 'not-allowed' : 'pointer';
        btn.style.filter   = blocked ? 'grayscale(1)' : 'none';
        btn._blocked       = blocked;
        _applyOptIcon(btn, opt, charState.category);
      });
      return;
    }

    container.innerHTML = '';
    container.style.cssText = 'display:flex;gap:8px;align-items:center;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;scrollbar-width:none;-ms-overflow-style:none;flex:1;max-width:260px;';
    container._optsKey = key;

    for (var i = 0; i < opts.length; i++) {
      var opt         = opts[i];
      var isSelected  = i === cur;
      var scale       = isSelected ? 1.1 : 1;
      var borderStyle = isSelected ? 'box-shadow:inset 0 0 0 3px #C1E5F1,0 2px 8px rgba(193,229,241,0.5);' : 'box-shadow:inset 0 0 0 2px #E5E5E5;';
      var btn = document.createElement('button');
      btn.style.cssText = 'width:40px;height:40px;border-radius:50%;background:white;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:20px;transition:all 0.3s ease;flex-shrink:0;transform:scale(' + scale + ');opacity:1;overflow:hidden;scroll-snap-align:center;' + borderStyle;
      _applyOptIcon(btn, opt, charState.category);
      btn.title = opt.name || '';
      var blocked = charState.category === 'hair' && isHairBlocked(i);
      btn._blocked = blocked;
      if (blocked) {
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
        btn.style.filter = 'grayscale(1)';
      }
      (function (idx) {
        btn.onclick = function () {
          // "this" = le bouton réellement cliqué (var btn est partagé par toute la boucle,
          // le lire ici retournerait toujours le DERNIER bouton créé et bloquerait tout
          // sélection dès qu'une seule option de la liste est bloquée).
          if (this._blocked) return;
          setCatIdx(idx);
          if (charState.category === 'accessories') applyHeadwearLogic();
          renderCharUI();
        };
      })(i);
      container.appendChild(btn);
    }

  }

  function renderColorOpts() {
    var row       = document.getElementById('pbColorRow');
    var container = document.getElementById('pbColorOptions');
    if (!row || !container) return;
    if (charState.category !== 'hair') { row.style.display = 'none'; }
    else {
      row.style.display = 'flex';
      container.innerHTML = '';

      var cur = charState.hairColorIdx;

      for (var i = 0; i < HAIR_COLORS.length; i++) {
        var c          = HAIR_COLORS[i];
        var isSelected = i === cur;
        var btn = document.createElement('button');
        btn.style.cssText = 'width:40px;height:40px;border-radius:50%;background:' + c.color + ';border:2px solid ' + (isSelected ? '#C1E5F1' : '#E5E5E5') + ';cursor:pointer;transition:all 0.2s;flex-shrink:0;scroll-snap-align:center;' + (isSelected ? 'box-shadow:0 2px 8px rgba(193,229,241,0.3);' : '');
        btn.title = c.name;
        (function (idx) { btn.onclick = function () { charState.hairColorIdx = idx; renderCharUI(); }; })(i);
        container.appendChild(btn);
      }

    }

    // Eyes color row — always hidden (options shown in variant buttons)
    var eyesRow = document.getElementById('pbEyesColorRow');
    if (eyesRow) eyesRow.style.display = 'none';
  }

  function updateCatLabel() {
    var map = { hair: 'Coiffure', accessories: 'Accessoires', glasses: 'Lunettes', skin: 'Teint', freckles: 'Taches de rousseur', eyes: 'Yeux', outfit: 'Tenue' };
    var label = document.getElementById('pbCategoryLabel');
    if (label) label.textContent = map[charState.category] || '';

    var info = document.getElementById('pbHairCompatInfo');
    if (info) {
      if (charState.category === 'accessories') {
        info.style.visibility = 'visible';
        info.textContent = charState.gender === 'girl'
          ? 'ℹ️ Certaines coiffures ne sont pas compatibles avec ce couvre-chef'
          : 'ℹ️ La coiffure s\'adapte automatiquement au couvre-chef choisi';
      } else {
        info.style.visibility = 'hidden';
      }
    }
  }

  function updateGenderBtns() {
    document.querySelectorAll('.pb-gender-btn').forEach(function (btn) {
      var active = btn.getAttribute('data-pb-gender') === charState.gender;
      btn.style.borderColor = active ? '#C1E5F1' : '#E5E5E5';
      btn.style.boxShadow   = active ? '0 2px 8px rgba(193,229,241,0.3)' : 'none';
    });
  }

  function updateFormTitle() {
    var el = document.getElementById('pbFormTitle');
    if (el) el.textContent = state.isSecondaryChar ? 'Informations du personnage secondaire' : 'Informations du personnage principal';
  }

  function updateFormFields() {
    var isPrimary = !state.isSecondaryChar;

    ['pbRevesGroup', 'pbAnecdotesGroup', 'pbDedicaceGroup'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = isPrimary ? 'block' : 'none';
    });

    var lienGroup = document.getElementById('pbLienGroup');
    if (lienGroup) lienGroup.style.display = !isPrimary ? 'block' : 'none';

    var lienLabel = document.getElementById('pbLienLabel');
    if (lienLabel) {
      var prenomEl = document.getElementById('pbPrenom');
      var prenom = prenomEl ? prenomEl.value.trim() : '';
      lienLabel.textContent = prenom ? 'Lien avec ' + prenom : 'Lien avec le héros';
    }
  }

  // ─── CANVAS RENDER ────────────────────────────────────────────────────────
  function applyLayerSettings(img, settings) {
    if (!settings) return;
    if (settings.top !== undefined)  img.style.top  = settings.top + '%';
    if (settings.left !== undefined) {
      img.style.left      = '50%';
      img.style.transform = 'translateX(calc(-50% + ' + (settings.left || 0) + 'px)) scale(' + ((settings.scale || 100) / 100) + ')';
    } else if (settings.scale !== undefined) {
      img.style.left      = '50%';
      img.style.transform = 'translateX(-50%) scale(' + (settings.scale / 100) + ')';
    }
  }

  function setLayer(el, opt, cat) {
    if (!el) return;
    if (!opt || opt.id === 'none') { el.style.display = 'none'; return; }
    var url = null;
    var settings = null;
    if ((cat === 'hair' || cat === 'eyebrows') && opt.colors) {
      var colorId   = HAIR_COLORS[charState.hairColorIdx] ? HAIR_COLORS[charState.hairColorIdx].id : null;
      var colorData = colorId ? opt.colors[colorId] : null;
      if (colorData) { url = colorData.url; settings = colorData.settings; }
    } else if (opt.url) {
      url = opt.url; settings = opt.settings;
    }
    if (url && url.indexOf('URL_') === -1) {
      if (el.getAttribute('src') !== url) {
        // Masquer tant que la NOUVELLE image n'est pas réellement affichable, puis révéler
        // uniquement sur onload/onerror. Un jeton de génération protège contre le cas où une
        // requête plus ANCIENNE (ex: coupe 5) répond APRÈS une requête plus RÉCENTE (coupe 6) déjà
        // affichée : sans lui, l'onload tardif de la coupe 5 écrase le src/settings de la coupe 6
        // et affiche la mauvaise image à la mauvaise position, parfois durablement (bug observé).
        var token = (el._layerToken = (el._layerToken || 0) + 1);
        el.style.display = 'none';
        var reveal = function () {
          if (el._layerToken !== token) return; // une sélection plus récente a déjà pris le dessus
          el.onload = null;
          el.onerror = null;
          if (settings) applyLayerSettings(el, settings);
          // Safari/WebKit peut peindre l'ANCIEN bitmap un instant après un changement de src,
          // même après onload (bug connu de repaint différé). Attendre deux frames avant de
          // révéler garantit que le compositeur a bien basculé sur la nouvelle image — Chrome
          // n'a pas ce défaut mais le double rAF ne coûte qu'un instant imperceptible.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (el._layerToken !== token) return;
              el.style.display = 'block';
            });
          });
        };
        el.onload = reveal;
        el.onerror = reveal; // en cas d'échec, ne pas laisser le calque invisible indéfiniment
        el.src = url;
        if (el.complete) reveal(); // image déjà en cache : affichable immédiatement
      } else {
        if (settings) applyLayerSettings(el, settings);
        el.style.display = 'block';
      }
    } else {
      el._layerToken = (el._layerToken || 0) + 1;
      el.src = '';
      el.style.display = 'none';
    }
  }

  function renderCanvas() {
    var base    = document.getElementById('pbBaseLayer');
    var skinEl  = document.getElementById('pbSkinLayer');
    var freckEl = document.getElementById('pbFrecklesLayer');
    var eyesEl  = document.getElementById('pbEyesLayer');
    var browEl  = document.getElementById('pbEyebrowsLayer');
    var glEl    = document.getElementById('pbGlassesLayer');
    var hairEl  = document.getElementById('pbHairLayer');
    var accEl   = document.getElementById('pbAccessoriesLayer');

    if (!base) return;

    // Skin / Outfit
    var activeSkinTones;
    if (charState.gender === 'girl') {
      activeSkinTones = (charState.outfitIdx === 0)
        ? (typeof SKIN_TONES_GIRL !== 'undefined' ? SKIN_TONES_GIRL : null)
        : (typeof SKIN_TONES_GIRL_JEAN !== 'undefined' ? SKIN_TONES_GIRL_JEAN : null);
    } else {
      activeSkinTones = getSkinTones(charState.gender);
    }
    var skinOpt = activeSkinTones ? activeSkinTones[charState.skinIdx] : null;
    setLayer(skinEl, skinOpt, 'skin');
    if (base) {
      base.style.display = (skinOpt && skinOpt.url) ? 'none' : 'block';
    }

    // Freckles
    setLayer(freckEl, FRECKLES_OPTIONS ? FRECKLES_OPTIONS[charState.frecklesIdx] : null, 'freckles');

    // Eyes
    setLayer(eyesEl, EYES_OPTIONS ? EYES_OPTIONS[charState.eyesIdx] : null, 'eyes');

    // Eyebrows (single style, color follows hair color)
    var browOpts = getEyebrowsOpts(charState.gender);
    setLayer(browEl, browOpts ? browOpts[0] : null, 'eyebrows');

    // Glasses
    setLayer(glEl, GLASSES_OPTIONS ? GLASSES_OPTIONS[charState.glassesIdx] : null, 'glasses');

    // Accessories (calculé avant les cheveux pour savoir si le voile doit les masquer)
    var accOpts    = getAccessoriesOpts(charState.gender);
    var currentAcc = accOpts ? accOpts[charState.accessoriesIdx] : null;
    setLayer(accEl, currentAcc, 'accessories');

    // Hair
    var hairStyles = getHairStyles(charState.gender);
    if (currentAcc && currentAcc.hideHair) {
      if (hairEl) hairEl.style.display = 'none';
    } else {
      setLayer(hairEl, hairStyles ? hairStyles[charState.hairIdx] : null, 'hair');
    }
  }

  // ─── PROGRESS DOTS ────────────────────────────────────────────────────────
  function renderProgressDots() {
    var container = document.getElementById('pbStepDots');
    if (!container) return;
    container.innerHTML = '';

    var cur = state.currentStep;
    var dotNum = 1;
    var totalDots = 0;
    var activeDotIdx = 0;

    // Count total and find active index
    var dots = [];

    // Pack dot
    var packState = (cur === 'pbStepPack') ? 'active' : 'completed';
    dots.push({ num: dotNum++, label: 'Pack', state: packState, step: 'pbStepPack', bookIdx: null });

    if (state.pack) {
      var bookCount = PACK_BOOK_COUNTS[state.pack] || 1;
      for (var b = 0; b < bookCount; b++) {
        var bd        = state.booksData[b] || {};
        var isCur     = b === state.currentBookIndex;
        var isBookStep = isCur && (cur === 'pbStepSecondary' || cur === 'pbStepChar' || cur === 'pbStepInfo');
        var charLabel = bookCount === 1
          ? (bd.primaryChar && bd.primaryChar.prenom ? bd.primaryChar.prenom : 'Héros')
          : (bd.primaryChar && bd.primaryChar.prenom ? bd.primaryChar.prenom : 'Livre ' + (b + 1));
        var charSt    = bd.primaryChar ? 'completed' : (isBookStep ? 'active' : '');
        dots.push({ num: dotNum++, label: charLabel, state: charSt, step: 'pbStepChar', bookIdx: b });

        var isCoverStep = isCur && cur === 'pbStepCover';
        var coverSt     = bd.coverType ? 'completed' : (isCoverStep ? 'active' : '');
        dots.push({ num: dotNum++, label: 'Couverture', state: coverSt, step: 'pbStepCover', bookIdx: b });
      }
    }

    var recapSt = cur === 'pbStepRecap' ? 'active' : '';
    dots.push({ num: dotNum++, label: 'Récap', state: recapSt, step: 'pbStepRecap', bookIdx: null });

    // Find active index for progress bar
    var activeIdx = 0;
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].state === 'active') { activeIdx = i; break; }
      if (dots[i].state === 'completed') activeIdx = i + 1;
    }
    var progressPct = dots.length > 1 ? Math.round((activeIdx / (dots.length - 1)) * 100) : 0;
    var progressBar = document.getElementById('pbProgressBar');
    if (progressBar) progressBar.style.width = progressPct + '%';

    for (var j = 0; j < dots.length; j++) {
      var d = dots[j];
      var dotEl = makeDot(d.num, d.label, d.state);
      if (d.state === 'completed') {
        (function(dot) {
          dotEl.onclick = function() {
            if (dot.bookIdx !== null) state.currentBookIndex = dot.bookIdx;
            goToStep(dot.step);
          };
        })(d);
      }
      container.appendChild(dotEl);
    }
  }

  function makeDot(num, label, stateClass) {
    var wrapper = document.createElement('div');
    wrapper.className = 'progress-step' + (stateClass ? ' ' + stateClass : '');
    wrapper.style.cursor = 'pointer';

    var numEl = document.createElement('div');
    numEl.className = 'progress-step-number';

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'progress-ring');
    svg.setAttribute('width', '50');
    svg.setAttribute('height', '50');

    var circleBg = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circleBg.setAttribute('class', 'progress-ring-bg');
    circleBg.setAttribute('cx', '25');
    circleBg.setAttribute('cy', '25');
    circleBg.setAttribute('r', '21');
    circleBg.setAttribute('fill', 'none');
    circleBg.setAttribute('stroke', '#D4EEF7');
    circleBg.setAttribute('stroke-width', '4');

    var circleFill = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circleFill.setAttribute('class', 'progress-ring-fill');
    circleFill.setAttribute('cx', '25');
    circleFill.setAttribute('cy', '25');
    circleFill.setAttribute('r', '21');
    circleFill.setAttribute('fill', 'none');
    circleFill.setAttribute('stroke', '#C1E5F1');
    circleFill.setAttribute('stroke-width', '4');
    circleFill.setAttribute('stroke-dasharray', '131.9');
    circleFill.setAttribute('stroke-dashoffset', stateClass === 'completed' ? '0' : '131.9');

    svg.appendChild(circleBg);
    svg.appendChild(circleFill);

    var numSpan = document.createElement('span');
    numSpan.className = 'progress-number';
    numSpan.textContent = num;

    var editSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    editSvg.setAttribute('class', 'edit-icon');
    editSvg.setAttribute('viewBox', '0 0 24 24');
    var ns = 'http://www.w3.org/2000/svg';
    function mkRect(x, y, w, h, rx, fill, stroke, sw) {
      var r = document.createElementNS(ns, 'rect');
      r.setAttribute('x', x); r.setAttribute('y', y);
      r.setAttribute('width', w); r.setAttribute('height', h);
      if (rx) r.setAttribute('rx', rx);
      r.setAttribute('fill', fill); r.setAttribute('stroke', stroke);
      r.setAttribute('stroke-width', sw);
      return r;
    }
    function mkPath(d, fill, stroke, sw, slj) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d); p.setAttribute('fill', fill);
      if (stroke) { p.setAttribute('stroke', stroke); p.setAttribute('stroke-width', sw); }
      if (slj) p.setAttribute('stroke-linejoin', slj);
      return p;
    }
    editSvg.appendChild(mkRect(10, 3, 4, 3, 1, '#FF8A80', '#555', '1.3'));
    editSvg.appendChild(mkRect(10, 6, 4, 1.5, null, '#BDBDBD', '#555', '1'));
    editSvg.appendChild(mkRect(10, 7.5, 4, 9, null, '#FFCA28', '#555', '1.3'));
    editSvg.appendChild(mkPath('M10 16.5L12 22L14 16.5Z', '#D4A574', '#555', '1.3', 'round'));
    editSvg.appendChild(mkPath('M11.2 20L12 22L12.8 20Z', '#555', null, null, null));

    numEl.appendChild(svg);
    numEl.appendChild(numSpan);
    numEl.appendChild(editSvg);

    var lblEl = document.createElement('div');
    lblEl.className = 'progress-step-label';
    lblEl.textContent = label;

    wrapper.appendChild(numEl);
    wrapper.appendChild(lblEl);
    return wrapper;
  }

  // ─── NAVIGATION RENDER ────────────────────────────────────────────────────
  function renderNav() {
    var prevBtn   = document.getElementById('pbPrevBtn');
    var nextBtn   = document.getElementById('pbNextBtn');
    var submitBtn = document.getElementById('pbSubmitBtn');
    if (!prevBtn || !nextBtn || !submitBtn) return;

    var step = state.currentStep;

    // Reset
    prevBtn.style.display   = 'none';
    nextBtn.style.display   = 'none';
    submitBtn.style.display = 'none';
    nextBtn.style.flex      = '1';
    submitBtn.style.flex    = '1';

    if (step === 'pbStepPack') {
      nextBtn.style.display = 'block';
      nextBtn.textContent   = 'Continuer';
      nextBtn.disabled      = false;
      nextBtn.style.opacity = '1';
      return;
    }

    if (step === 'pbStepRecap') {
      prevBtn.style.display   = 'block';
      submitBtn.style.display = 'block';
      return;
    }

    if (step === 'pbStepTransition') {
      nextBtn.style.display = 'block';
      nextBtn.textContent   = 'Commencer le livre suivant';
      nextBtn.disabled      = false;
      nextBtn.style.opacity = '1';
      return;
    }

    if (step === 'pbStepCharPicker') {
      prevBtn.style.display = 'block';
      nextBtn.style.display = 'block';
      nextBtn.textContent   = 'Confirmer';
      nextBtn.disabled      = false;
      nextBtn.style.opacity = '1';
      return;
    }

    // All other steps
    prevBtn.style.display = 'block';
    nextBtn.style.display = 'block';
    nextBtn.textContent   = 'Continuer';
    var canGo = canProceed();
    nextBtn.disabled      = !canGo;
    nextBtn.style.opacity = canGo ? '1' : '0.5';
  }

  function canProceed() {
    var step = state.currentStep;
    if (step === 'pbStepInfo') {
      var prenomEl = document.getElementById('pbPrenom');
      var ageEl    = document.getElementById('pbAge');
      return !!(prenomEl && prenomEl.value.trim() && ageEl && ageEl.value);
    }
    if (step === 'pbStepCover') {
      var bd = state.booksData[state.currentBookIndex];
      return !!(bd && bd.coverType);
    }
    return true;
  }

  // ─── BOOK INDICATORS ──────────────────────────────────────────────────────
  function updateBookIndicators() {
    var bookCount = state.pack ? (PACK_BOOK_COUNTS[state.pack] || 1) : 1;
    var label     = 'Livre ' + (state.currentBookIndex + 1) + ' sur ' + bookCount;
    var show      = bookCount > 1;
    ['pbSecondaryBookLabel', 'pbCharBookLabel', 'pbInfoBookLabel', 'pbCoverBookLabel'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.textContent = label; el.style.display = show ? 'block' : 'none'; }
    });
  }

  // ─── STEP TRANSITIONS ─────────────────────────────────────────────────────
  function goToStep(stepId) {
    document.querySelectorAll('.step').forEach(function (s) { s.classList.remove('active'); });
    var el = document.getElementById(stepId);
    if (el) {
      el.classList.add('active');
      var prog = document.querySelector('.progress-container');
      if (prog) {
        var top = prog.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
    state.currentStep = stepId;
    updateBookIndicators();
    renderProgressDots();
    renderNav();
    if (stepId === 'pbStepSecondary') syncSecondaryToggle();
  }

  function nextStep() {
    var step = state.currentStep;

    if (step === 'pbStepPack') {
      if (!state.pack) {
        var grid = document.querySelector('.pb-pack-grid');
        if (grid) {
          grid.style.animation = 'none';
          grid.offsetHeight;
          grid.style.animation = 'pbShake 0.4s ease';
        }
        return;
      }
      var bookCount = PACK_BOOK_COUNTS[state.pack];
      state.booksData = [];
      for (var i = 0; i < bookCount; i++) {
        state.booksData.push({ coverType: null, hasSecondary: false, primaryChar: null, secondaryChar: null, secondaryDecided: false });
      }
      state.currentBookIndex = 0;
      state.isSecondaryChar  = false;
      charState = createDefaultCharState();
      goToStep('pbStepChar');
      renderCharUI();
      updateCharTitleForRole(false);
      return;
    }

    if (step === 'pbStepSecondary') {
      var bd = state.booksData[state.currentBookIndex];
      // bd.hasSecondary already set by toggle click
      state.isSecondaryChar = false;
      if (secondaryAfterCover) {
        if (bd.hasSecondary) {
          state.isSecondaryChar = true;
          charState = createDefaultCharState();
          goToStep('pbStepChar');
          renderCharUI();
          updateCharTitleForRole(true);
        } else {
          secondaryAfterCover = false;
          var totalBooksQ = PACK_BOOK_COUNTS[state.pack] || 1;
          if (state.currentBookIndex < totalBooksQ - 1) {
            renderTransition();
            goToStep('pbStepTransition');
          } else {
            renderRecap();
            goToStep('pbStepRecap');
          }
        }
      } else if (pickerActive) {
        renderCharUI();
        goToStep('pbStepInfo');
      } else {
        // re-proposal after primary info (book 1+)
        secondaryReproposed = false;
        if (bd.hasSecondary) {
          state.isSecondaryChar = true;
          charState = createDefaultCharState();
          goToStep('pbStepChar');
          renderCharUI();
          updateCharTitleForRole(true);
        } else {
          goToStep('pbStepCover');
          resetCoverSelection();
        }
      }
      return;
    }

    if (step === 'pbStepChar') {
      goToStep('pbStepInfo');
      return;
    }

    if (step === 'pbStepInfo') {
      var bdata = state.booksData[state.currentBookIndex];
      var saved = saveCharData();
      if (state.isSecondaryChar) {
        bdata.secondaryChar   = saved;
        state.isSecondaryChar = false;
        pickerActive = false;
        pickerSecondaryChar = null;
        if (secondaryAfterCover) {
          secondaryAfterCover = false;
          var totalBooksS = PACK_BOOK_COUNTS[state.pack] || 1;
          if (state.currentBookIndex < totalBooksS - 1) {
            renderTransition();
            goToStep('pbStepTransition');
          } else {
            renderRecap();
            goToStep('pbStepRecap');
          }
        } else {
          goToStep('pbStepCover');
          resetCoverSelection();
        }
      } else {
        bdata.primaryChar = saved;
        if (state.currentBookIndex === 0) {
          // secondary question comes after cover for book 0
          pickerActive = false;
          pickerSecondaryChar = null;
          goToStep('pbStepCover');
          resetCoverSelection();
        } else if (bdata.hasSecondary) {
          state.isSecondaryChar = true;
          if (pickerActive && pickerSecondaryChar && pickerSecondaryChar !== 'new') {
            var s = pickerSecondaryChar;
            charState = createDefaultCharState();
            charState.gender         = s.gender         || 'boy';
            charState.hairIdx        = s.hairIdx         || 0;
            charState.hairColorIdx   = s.hairColorIdx    || 0;
            charState.skinIdx        = s.skinIdx         || 0;
            charState.frecklesIdx    = s.frecklesIdx     || 0;
            charState.eyesIdx        = s.eyesIdx         || 0;
            charState.accessoriesIdx = s.accessoriesIdx  || 0;
            charState.glassesIdx     = s.glassesIdx      || 0;
            charState.outfitIdx      = s.outfitIdx       || 0;
            charState.imageUrl       = s.imageUrl         || '';
            goToStep('pbStepInfo');
            updateCharTitleForRole(true);
            updateFormFields();
            // pack-secondary-fix.js clears fields on title change via setTimeout(0)
            // so we re-fill slightly after to override it
            var sPrenom = s.prenom, sAge = s.age;
            restoreFormFields({ prenom: sPrenom, age: sAge });
            setTimeout(function() { restoreFormFields({ prenom: sPrenom, age: sAge }); }, 20);
          } else {
            charState = createDefaultCharState();
            goToStep('pbStepChar');
            renderCharUI();
            updateCharTitleForRole(true);
          }
          pickerActive = false;
          pickerSecondaryChar = null;
        } else {
          pickerActive = false;
          pickerSecondaryChar = null;
          // re-propose secondary if picker didn't choose one
          secondaryReproposed = true;
          resetSecondaryChoice();
          goToStep('pbStepSecondary');
        }
      }
      return;
    }

    if (step === 'pbStepCover') {
      var bdCov = state.booksData[state.currentBookIndex];
      if (state.currentBookIndex === 0 && !bdCov.secondaryDecided) {
        bdCov.secondaryDecided = true;
        secondaryAfterCover = true;
        resetSecondaryChoice();
        goToStep('pbStepSecondary');
        return;
      }
      var totalBooks = PACK_BOOK_COUNTS[state.pack] || 1;
      if (state.currentBookIndex < totalBooks - 1) {
        renderTransition();
        goToStep('pbStepTransition');
      } else {
        renderRecap();
        goToStep('pbStepRecap');
      }
      return;
    }

    if (step === 'pbStepTransition') {
      state.currentBookIndex++;
      state.isSecondaryChar = false;
      var allPrevChars = getAllPrevChars();
      if (allPrevChars.length > 0) {
        renderCharPicker(allPrevChars);
        goToStep('pbStepCharPicker');
      } else {
        var bdTrans = state.booksData[state.currentBookIndex];
        if (bdTrans) bdTrans.hasSecondary = false;
        charState = createDefaultCharState();
        restoreFormFields({});
        goToStep('pbStepChar');
        renderCharUI();
        updateCharTitleForRole(false);
      }
      return;
    }

    if (step === 'pbStepCharPicker') {
      var bd = state.booksData[state.currentBookIndex];
      if (pickerPrimaryChar) {
        var p = pickerPrimaryChar;
        charState = createDefaultCharState();
        charState.gender         = p.gender         || 'boy';
        charState.hairIdx        = p.hairIdx         || 0;
        charState.hairColorIdx   = p.hairColorIdx    || 0;
        charState.skinIdx        = p.skinIdx         || 0;
        charState.frecklesIdx    = p.frecklesIdx     || 0;
        charState.eyesIdx        = p.eyesIdx         || 0;
        charState.accessoriesIdx = p.accessoriesIdx  || 0;
        charState.glassesIdx     = p.glassesIdx      || 0;
        charState.outfitIdx      = p.outfitIdx       || 0;
        charState.imageUrl       = p.imageUrl         || '';
        restoreFormFields({ prenom: p.prenom, age: p.age });
        bd.hasSecondary = (pickerSecondaryChar !== null);
        pickerActive = true;
        pickerSkippedChar = true;
        state.isSecondaryChar = false;
        goToStep('pbStepInfo');
        updateCharTitleForRole(false);
        updateFormFields();
      } else {
        charState = createDefaultCharState();
        restoreFormFields({});
        var bdNew = state.booksData[state.currentBookIndex];
        bdNew.hasSecondary = (pickerSecondaryChar !== null);
        pickerActive = false;
        pickerPrimaryChar = null;
        goToStep('pbStepChar');
        renderCharUI();
        updateCharTitleForRole(false);
      }
      return;
    }
  }

  function prevStep() {
    var step = state.currentStep;

    if (step === 'pbStepCharPicker') {
      state.currentBookIndex--;
      pickerPrimaryChar = null;
      pickerSecondaryChar = null;
      pickerActive = false;
      renderTransition();
      goToStep('pbStepTransition');
      return;
    }

    if (step === 'pbStepSecondary') {
      if (secondaryAfterCover) {
        secondaryAfterCover = false;
        var bdsBack = state.booksData[state.currentBookIndex];
        if (bdsBack) { bdsBack.secondaryDecided = false; bdsBack.hasSecondary = false; }
        goToStep('pbStepCover');
        restoreCoverSelection();
      } else if (secondaryReproposed) {
        secondaryReproposed = false;
        state.isSecondaryChar = false;
        var bdSRP = state.booksData[state.currentBookIndex];
        restoreCharFromBook(false);
        restoreFormFields(bdSRP && bdSRP.primaryChar);
        goToStep('pbStepInfo');
        updateCharTitleForRole(false);
        updateFormFields();
        renderCharUI();
      } else if (state.currentBookIndex === 0) {
        goToStep('pbStepPack');
      } else {
        var allPrevCharsBack = getAllPrevChars();
        if (allPrevCharsBack.length > 0) {
          renderCharPicker(allPrevCharsBack);
          goToStep('pbStepCharPicker');
        } else {
          state.currentBookIndex--;
          goToStep('pbStepCover');
          restoreCoverSelection();
        }
      }
      return;
    }

    if (step === 'pbStepChar') {
      if (state.isSecondaryChar) {
        if (secondaryAfterCover) {
          state.isSecondaryChar = false;
          goToStep('pbStepSecondary');
        } else if (secondaryReproposed) {
          state.isSecondaryChar = false;
          goToStep('pbStepSecondary');
        } else {
          restoreCharFromBook(false);
          state.isSecondaryChar = false;
          goToStep('pbStepInfo');
          restoreFormFields(state.booksData[state.currentBookIndex] && state.booksData[state.currentBookIndex].primaryChar);
          updateCharTitleForRole(false);
          updateFormFields();
        }
      } else {
        if (state.currentBookIndex === 0) {
          goToStep('pbStepPack');
        } else {
          var allPrevCharsCharBack = getAllPrevChars();
          if (allPrevCharsCharBack.length > 0) {
            renderCharPicker(allPrevCharsCharBack);
            goToStep('pbStepCharPicker');
          } else {
            state.currentBookIndex--;
            renderTransition();
            goToStep('pbStepTransition');
          }
        }
      }
      renderCharUI();
      return;
    }

    if (step === 'pbStepInfo') {
      if (pickerSkippedChar && !state.isSecondaryChar) {
        pickerSkippedChar = false;
        var allPrevCharsBack2 = getAllPrevChars();
        renderCharPicker(allPrevCharsBack2);
        goToStep('pbStepCharPicker');
      } else {
        goToStep('pbStepChar');
        renderCharUI();
      }
      return;
    }

    if (step === 'pbStepCover') {
      var bd2 = state.booksData[state.currentBookIndex];
      if (state.currentBookIndex === 0) {
        // secondary question comes after cover, so going back means primary info
        state.isSecondaryChar = false;
        restoreCharFromBook(false);
        restoreFormFields(bd2 && bd2.primaryChar);
        goToStep('pbStepInfo');
        updateCharTitleForRole(false);
        updateFormFields();
      } else if (bd2 && bd2.hasSecondary) {
        state.isSecondaryChar = true;
        restoreCharFromBook(true);
        restoreFormFields(bd2.secondaryChar);
        goToStep('pbStepInfo');
        updateCharTitleForRole(true);
        updateFormFields();
      } else {
        state.isSecondaryChar = false;
        restoreCharFromBook(false);
        restoreFormFields(bd2 && bd2.primaryChar);
        goToStep('pbStepInfo');
        updateCharTitleForRole(false);
        updateFormFields();
      }
      renderCharUI();
      return;
    }

    if (step === 'pbStepRecap') {
      state.currentBookIndex = (PACK_BOOK_COUNTS[state.pack] || 1) - 1;
      goToStep('pbStepCover');
      restoreCoverSelection();
      return;
    }
  }

  // ─── CHAR DATA SAVE / RESTORE ─────────────────────────────────────────────
  function saveCharData() {
    return {
      gender:         charState.gender,
      hairIdx:        charState.hairIdx,
      hairColorIdx:   charState.hairColorIdx,
      accessoriesIdx: charState.accessoriesIdx,
      glassesIdx:     charState.glassesIdx,
      skinIdx:        charState.skinIdx,
      frecklesIdx:    charState.frecklesIdx,
      eyesIdx:        charState.eyesIdx,
      outfitIdx:      charState.outfitIdx,
      prenom:   (document.getElementById('pbPrenom')    || {}).value || '',
      age:      (document.getElementById('pbAge')       || {}).value || '',
      reves:    (document.getElementById('pbReves')     || {}).value || '',
      anecdotes:(document.getElementById('pbAnecdotes') || {}).value || '',
      dedicace: (document.getElementById('pbDedicace')  || {}).value || '',
      lien:     (document.getElementById('pbLien')      || {}).value || '',
      imageUrl: charState.imageUrl || ''
    };
  }

  function restoreCharFromBook(isSecondary) {
    var bd     = state.booksData[state.currentBookIndex];
    var saved  = isSecondary ? (bd && bd.secondaryChar) : (bd && bd.primaryChar);
    if (!saved) { charState = createDefaultCharState(); return; }
    charState = {
      gender:         saved.gender         || 'boy',
      category:       'skin',
      hairIdx:        saved.hairIdx        || 0,
      savedHairIdx:   -1,
      hairColorIdx:   saved.hairColorIdx   || 0,
      accessoriesIdx: saved.accessoriesIdx || 0,
      glassesIdx:     saved.glassesIdx     || 0,
      skinIdx:        saved.skinIdx        || 0,
      frecklesIdx:    saved.frecklesIdx    || 0,
      eyesIdx:        saved.eyesIdx        || 0,
      outfitIdx:      saved.outfitIdx      || 0,
      prenom:   saved.prenom   || '',
      age:      saved.age      || '',
      reves:    saved.reves    || '',
      anecdotes:saved.anecdotes|| '',
      dedicace: saved.dedicace || '',
      lien:     saved.lien     || '',
      imageUrl: saved.imageUrl || ''
    };
  }

  function restoreFormFields(charData) {
    if (!charData) return;
    var map = { pbPrenom: 'prenom', pbAge: 'age', pbReves: 'reves', pbAnecdotes: 'anecdotes', pbDedicace: 'dedicace', pbLien: 'lien' };
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.value = charData[map[id]] || '';
    });
  }

  function updateCharTitleForRole(isSecondary) {
    var titleEl    = document.getElementById('pbCharTitle');
    var subtitleEl = document.getElementById('pbCharSubtitle');
    if (titleEl)    titleEl.textContent    = isSecondary ? 'Créez le personnage secondaire'      : 'Créez le personnage principal';
    if (subtitleEl) subtitleEl.textContent = isSecondary ? 'Apparence du 2ème personnage'        : 'Personnalisez l\'apparence du héros';
    updateFormTitle();
  }

  // ─── COVER SELECTION ───────────────────────────────────────────────────
  function resetCoverSelection() {
    document.querySelectorAll('.pb-cover-card').forEach(function (c) { c.classList.remove('selected'); });
    var bd = state.booksData[state.currentBookIndex];
    if (bd && bd.coverType) {
      var card = document.querySelector('.pb-cover-card[data-pb-cover="' + bd.coverType + '"]');
      if (card) card.classList.add('selected');
    }
    renderNav();
  }

  function restoreCoverSelection() {
    resetCoverSelection();
  }

  // ─── SECONDARY CHOICE RESET ───────────────────────────────────────────────
  function resetSecondaryChoice() {
    state.isSecondaryChar = false;
    var bd = state.booksData[state.currentBookIndex];
    if (bd) bd.hasSecondary = false;
    var toggle   = document.getElementById('pbSecondaryToggle');
    var checkbox = document.getElementById('pbSecondaryCheckbox');
    if (toggle)   toggle.classList.remove('active');
    if (checkbox) checkbox.checked = false;
  }

  function syncSecondaryToggle() {
    var bd = state.booksData[state.currentBookIndex];
    var hasS = bd ? bd.hasSecondary : false;
    var toggle   = document.getElementById('pbSecondaryToggle');
    var checkbox = document.getElementById('pbSecondaryCheckbox');
    if (toggle)   toggle.classList.toggle('active', hasS);
    if (checkbox) checkbox.checked = hasS;
  }

  // ─── TRANSITION ───────────────────────────────────────────────────────────
  function getAllPrevChars() {
    var chars = [];
    var seen  = {};
    for (var i = 0; i < state.currentBookIndex; i++) {
      var bd = state.booksData[i];
      if (!bd) continue;
      if (bd.primaryChar && bd.primaryChar.prenom) {
        var key = bd.primaryChar.prenom + '|' + (bd.primaryChar.imageUrl || '');
        if (!seen[key]) { seen[key] = true; chars.push(bd.primaryChar); }
      }
      if (bd.secondaryChar && bd.secondaryChar.prenom) {
        var key2 = bd.secondaryChar.prenom + '|' + (bd.secondaryChar.imageUrl || '');
        if (!seen[key2]) { seen[key2] = true; chars.push(bd.secondaryChar); }
      }
    }
    return chars;
  }

  function injectCharPickerStep() {
    if (document.getElementById('pbStepCharPicker')) return;
    var el = document.createElement('div');
    el.id = 'pbStepCharPicker';
    el.className = 'step';
    el.innerHTML = '<div id="pbCharPickerContent"></div>';
    var form = document.getElementById('pbStepTransition');
    if (form && form.parentNode) form.parentNode.insertBefore(el, form.nextSibling);
  }

  function renderCharPicker(chars) {
    var container = document.getElementById('pbCharPickerContent');
    if (!container) return;

    pickerPrimaryChar   = chars[0] || null;
    pickerSecondaryChar = null;
    var showSecondary   = false;

    function setSelected(cards, selectedCard, accent) {
      cards.forEach(function (c) {
        var isActive = (c === selectedCard);
        c.style.borderColor = isActive ? accent : '#e8e8e8';
        c.style.background  = isActive ? (accent === '#3A9DB8' ? '#EEF9FD' : '#EDF7F2') : '#fff';
        c.style.boxShadow   = isActive ? '0 4px 12px rgba(0,0,0,0.10)' : '0 2px 6px rgba(0,0,0,0.04)';
        var ck = c.querySelector('.pb-picker-check');
        if (ck) ck.style.display = isActive ? 'flex' : 'none';
      });
    }

    function makeCard(char, accent) {
      var card = document.createElement('div');
      card.style.cssText = 'position:relative;display:flex;flex-direction:column;align-items:center;gap:8px;cursor:pointer;padding:14px 12px 12px;border-radius:16px;border:2px solid #e8e8e8;background:#fff;width:96px;box-shadow:0 2px 6px rgba(0,0,0,0.04);transition:border-color 0.15s,box-shadow 0.15s,background 0.15s;';
      var check = document.createElement('div');
      check.className = 'pb-picker-check';
      check.style.cssText = 'display:none;position:absolute;top:6px;right:6px;width:18px;height:18px;border-radius:50%;background:' + accent + ';align-items:center;justify-content:center;';
      check.innerHTML = '<svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4l3 3 5-6" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      card.appendChild(check);
      if (char === 'new') {
        var icon = document.createElement('div');
        icon.style.cssText = 'width:72px;height:72px;border-radius:50%;background:#f5f5f5;display:flex;align-items:center;justify-content:center;';
        icon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12h14" stroke="#bbb" stroke-width="2.2" stroke-linecap="round"/></svg>';
        var lbl = document.createElement('div');
        lbl.style.cssText = 'font-size:11px;font-weight:600;color:#888;text-align:center;line-height:1.3;';
        lbl.textContent = 'Nouveau';
        card.appendChild(icon);
        card.appendChild(lbl);
        card.style.border = '2px dashed #ccc';
      } else {
        if (char.imageUrl) {
          var img = document.createElement('img');
          img.src = char.imageUrl;
          img.style.cssText = 'width:72px;height:72px;border-radius:50%;object-fit:cover;border:2px solid #C1E5F1;';
          card.appendChild(img);
        } else {
          var av = document.createElement('div');
          av.style.cssText = 'width:72px;height:72px;border-radius:50%;background:#EAF6FB;display:flex;align-items:center;justify-content:center;';
          av.innerHTML = '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="4" fill="#3A9DB8" opacity="0.7"/><path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#3A9DB8" stroke-width="1.8" stroke-linecap="round" opacity="0.7"/></svg>';
          card.appendChild(av);
        }
        var nm = document.createElement('div');
        nm.style.cssText = 'font-size:12px;font-weight:700;color:#1a1a1a;text-align:center;max-width:88px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
        nm.textContent = char.prenom || '—';
        var ag = document.createElement('div');
        ag.style.cssText = 'font-size:11px;color:#888;margin-top:-4px;';
        ag.textContent = char.age ? char.age + ' ans' : '';
        card.appendChild(nm);
        card.appendChild(ag);
      }
      return card;
    }

    function buildPrimaryCards(row) {
      var allCards = [];
      chars.forEach(function (char) {
        var card = makeCard(char, '#3A9DB8');
        card.addEventListener('click', function () {
          pickerPrimaryChar = char;
          setSelected(allCards, card, '#3A9DB8');
        });
        allCards.push(card);
        row.appendChild(card);
      });
      var newCard = makeCard('new', '#3A9DB8');
      newCard.addEventListener('click', function () {
        pickerPrimaryChar = null;
        setSelected(allCards, newCard, '#3A9DB8');
      });
      allCards.push(newCard);
      row.appendChild(newCard);
      setSelected(allCards, allCards[0], '#3A9DB8');
      return allCards;
    }

    function buildSecondaryCards(row) {
      var allCards = [];
      chars.forEach(function (char) {
        var card = makeCard(char, '#5DAD88');
        card.addEventListener('click', function () {
          pickerSecondaryChar = char;
          setSelected(allCards, card, '#5DAD88');
        });
        allCards.push(card);
        row.appendChild(card);
      });
      var newCard = makeCard('new', '#5DAD88');
      newCard.addEventListener('click', function () {
        pickerSecondaryChar = 'new';
        setSelected(allCards, newCard, '#5DAD88');
      });
      allCards.push(newCard);
      row.appendChild(newCard);
      return allCards;
    }

    container.innerHTML = '';

    // ── Titre ──
    var title = document.createElement('div');
    title.style.cssText = 'font-size:20px;font-weight:800;color:#1a1a1a;margin-bottom:4px;text-align:center;';
    title.textContent = 'Personnages du livre suivant';
    var sub = document.createElement('div');
    sub.style.cssText = 'font-size:13px;color:#999;margin-bottom:22px;text-align:center;';
    sub.textContent = 'Réutilisez un personnage existant ou créez-en un nouveau.';
    container.appendChild(title);
    container.appendChild(sub);

    // ── Section principale ──
    var sec1 = document.createElement('div');
    sec1.style.cssText = 'margin-bottom:20px;';
    var lbl1 = document.createElement('div');
    lbl1.style.cssText = 'font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.8px;color:#3A9DB8;margin-bottom:12px;text-align:center;';
    lbl1.textContent = 'Personnage principal';
    sec1.appendChild(lbl1);
    var row1 = document.createElement('div');
    row1.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;justify-content:center;';
    buildPrimaryCards(row1);
    sec1.appendChild(row1);
    container.appendChild(sec1);

    // ── Toggle personnage secondaire ──
    var toggleWrap = document.createElement('label');
    toggleWrap.style.cssText = 'display:flex;align-items:center;gap:12px;padding:14px 16px;background:#FAFAFA;border:1.5px solid #eee;border-radius:14px;cursor:pointer;user-select:none;margin-bottom:0;';
    var toggleInput = document.createElement('input');
    toggleInput.type = 'checkbox';
    toggleInput.style.cssText = 'width:18px;height:18px;accent-color:#5DAD88;cursor:pointer;flex-shrink:0;';
    var toggleTxt = document.createElement('div');
    toggleTxt.innerHTML = '<div style="font-size:13px;font-weight:700;color:#1a1a1a;">Ajouter un personnage secondaire</div><div style="font-size:11px;color:#aaa;margin-top:2px;">Un frère, une sœur, un(e) ami(e)…</div>';
    toggleWrap.appendChild(toggleInput);
    toggleWrap.appendChild(toggleTxt);
    container.appendChild(toggleWrap);

    // ── Section secondaire (masquée par défaut) ──
    var sec2 = document.createElement('div');
    sec2.style.cssText = 'margin-top:16px;display:none;';
    var lbl2 = document.createElement('div');
    lbl2.style.cssText = 'font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:0.8px;color:#5DAD88;margin-bottom:12px;text-align:center;';
    lbl2.textContent = 'Personnage secondaire';
    sec2.appendChild(lbl2);
    var row2 = document.createElement('div');
    row2.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;justify-content:center;';
    buildSecondaryCards(row2);
    sec2.appendChild(row2);
    container.appendChild(sec2);

    toggleInput.addEventListener('change', function () {
      showSecondary = this.checked;
      sec2.style.display = showSecondary ? 'block' : 'none';
      if (!showSecondary) pickerSecondaryChar = null;
    });
  }

  function renderTransition() {
    var bookIdx   = state.currentBookIndex;
    var bookCount = PACK_BOOK_COUNTS[state.pack] || 1;

    var titleEl   = document.getElementById('pbTransitionTitle');
    var subEl     = document.getElementById('pbTransitionSub');
    var nextNumEl = document.getElementById('pbTransitionNextNum');
    var totalEl   = document.getElementById('pbTransitionTotalNum');
    var doneEl    = document.getElementById('pbTransitionDoneBooks');

    if (titleEl)   titleEl.textContent = 'Livre ' + (bookIdx + 1) + ' terminé !';
    if (subEl)     subEl.textContent   = 'Excellent ! Passons au livre suivant.';
    if (nextNumEl) nextNumEl.textContent = bookIdx + 2;
    if (totalEl)   totalEl.textContent   = bookCount;

    if (!doneEl) return;
    doneEl.innerHTML = '';
    for (var i = 0; i <= bookIdx; i++) {
      var bd = state.booksData[i];
      if (!bd || !bd.primaryChar) continue;
      var div = document.createElement('div');
      div.className = 'pb-transition-done';
      var lbl = document.createElement('div');
      lbl.className   = 'pb-transition-done-label';
      lbl.textContent = 'Livre ' + (i + 1) + (bd.coverType ? ' · ' + bd.coverType : '');
      var chars = document.createElement('div');
      chars.className = 'pb-transition-done-chars';
      chars.appendChild(makeDoneChar(bd.primaryChar, '#C1E5F1'));
      if (bd.secondaryChar) chars.appendChild(makeDoneChar(bd.secondaryChar, '#8ECFE8'));
      div.appendChild(lbl);
      div.appendChild(chars);
      doneEl.appendChild(div);
    }

  }

  function makeDoneChar(cd, color) {
    var el   = document.createElement('div');
    el.className = 'pb-transition-done-char';
    var dot  = document.createElement('div');
    dot.className = 'pb-transition-done-dot';
    dot.style.background = color;
    var name = document.createElement('div');
    name.className = 'pb-transition-done-name';
    name.textContent = cd.prenom || '—';
    var age  = document.createElement('div');
    age.className = 'pb-transition-done-age';
    age.textContent = cd.age ? cd.age + ' ans' : '';
    el.appendChild(dot); el.appendChild(name); el.appendChild(age);
    return el;
  }

  // ─── RECAP ────────────────────────────────────────────────────────────────
  function renderRecap() {
    var container = document.getElementById('pbRecapContent');
    if (!container) return;
    container.innerHTML = '';

    // Pack banner
    var bookCount = PACK_BOOK_COUNTS[state.pack] || 1;
    var packCard  = document.createElement('div');
    packCard.className = 'pb-recap-pack';
    packCard.innerHTML =
      '<div class="pb-recap-pack-label">Votre pack</div>' +
      '<div class="pb-recap-pack-title">' + state.pack + '</div>' +
      '<div class="pb-recap-pack-sub">' + bookCount + ' livre' + (bookCount > 1 ? 's' : '') + ' personnalisé' + (bookCount > 1 ? 's' : '') + '</div>';
    container.appendChild(packCard);

    for (var i = 0; i < state.booksData.length; i++) {
      var bd = state.booksData[i];
      var bookEl = document.createElement('div');
      bookEl.className = 'pb-recap-book';

      var header = document.createElement('div');
      header.className = 'pb-recap-book-header';

      var numBadge = document.createElement('div');
      numBadge.className   = 'pb-recap-book-num';
      numBadge.textContent = i + 1;

      var titleWrap = document.createElement('div');
      titleWrap.style.flex = '1';
      var bTitle = document.createElement('div');
      bTitle.className   = 'pb-recap-book-title';
      bTitle.textContent = 'Livre ' + (i + 1);
      var bCover = document.createElement('div');
      bCover.className   = 'pb-recap-book-cover';
      bCover.textContent = bd.coverType || '';
      titleWrap.appendChild(bTitle);
      titleWrap.appendChild(bCover);

      var editBtn = document.createElement('button');
      editBtn.className   = 'pb-recap-edit-btn';
      editBtn.textContent = '✏ Modifier';
      (function (idx) {
        editBtn.onclick = function () {
          state.currentBookIndex = idx;
          state.isSecondaryChar  = false;
          restoreCharFromBook(false);
          renderCharUI();
          goToStep('pbStepSecondary');
        };
      })(i);

      header.appendChild(numBadge);
      header.appendChild(titleWrap);
      header.appendChild(editBtn);
      bookEl.appendChild(header);

      var body = document.createElement('div');
      body.className = 'pb-recap-book-body';
      if (bd.primaryChar)   body.appendChild(makeRecapChar(bd.primaryChar,   'Héros principal',        '#C1E5F1'));
      if (bd.secondaryChar) body.appendChild(makeRecapChar(bd.secondaryChar, 'Personnage secondaire',  '#8ECFE8'));
      bookEl.appendChild(body);
      container.appendChild(bookEl);
    }

    var coverBases = {};
    for (var ci = 0; ci < state.booksData.length; ci++) {
      var ct = state.booksData[ci].coverType || '';
      var base = ct.indexOf('Rigide') === 0 ? 'Rigide' : (ct.indexOf('Souple') === 0 ? 'Souple' : ct);
      if (base) coverBases[base] = true;
    }
    if (Object.keys(coverBases).length > 1) {
      var shippingNotice = document.createElement('div');
      shippingNotice.className = 'pb-recap-shipping-notice';
      shippingNotice.innerHTML =
        '<span class="pb-recap-shipping-icon">📦</span>' +
        '<span>Vos livres ont des couvertures différentes (rigide et souple). Pour des raisons de production, votre commande peut être expédiée en 2 colis distincts.</span>';
      container.appendChild(shippingNotice);
    }
  }

  function makeRecapChar(cd, role, color) {
    var div  = document.createElement('div');
    div.className = 'pb-recap-char';
    var dot  = document.createElement('div');
    dot.className = 'pb-recap-dot';
    dot.style.background = color;
    var info = document.createElement('div');
    info.style.flex = '1';
    var roleEl = document.createElement('div');
    roleEl.className   = 'pb-recap-char-role';
    roleEl.textContent = role;
    var nameEl = document.createElement('div');
    nameEl.className   = 'pb-recap-char-name';
    nameEl.textContent = cd.prenom || '—';
    var detailEl = document.createElement('div');
    detailEl.className = 'pb-recap-char-detail';
    var parts = [];
    if (cd.age)  parts.push(cd.age + ' ans');
    if (cd.lien) parts.push(cd.lien);
    detailEl.textContent = parts.join(' · ');
    info.appendChild(roleEl); info.appendChild(nameEl); info.appendChild(detailEl);
    div.appendChild(dot); div.appendChild(info);
    return div;
  }

  // ─── VARIANT KEY ──────────────────────────────────────────────────────────
  function buildVariantKey() {
    if (!state.pack || !state.booksData.length) return null;
    var covers   = state.booksData.map(function (bd) { return bd.coverType || 'Souple 20x20'; });
    var countMap = {};
    covers.forEach(function (c) { countMap[c] = (countMap[c] || 0) + 1; });
    var ordered = ['Rigide 20x20', 'Souple 14x14', 'Souple 20x20'];
    var parts   = [];
    ordered.forEach(function (t) { if (countMap[t]) parts.push(countMap[t] + ' ' + t); });
    var combo    = parts.join(' + ');
    var hasAny   = state.booksData.some(function (bd) { return bd.hasSecondary; });
    return state.pack + '|' + combo + '|' + (hasAny ? 'Avec' : 'Sans');
  }

  // ─── ADD TO CART ──────────────────────────────────────────────────────────
  function addToCart() {
    var key = buildVariantKey();
    if (!key) { alert('Veuillez compléter toutes les étapes.'); return; }
    var variantId = VARIANT_MAP[key];
    if (!variantId) { alert('Combinaison non disponible. Clé : ' + key); return; }

    var submitBtn = document.getElementById('pbSubmitBtn');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Ajout en cours...'; }

    var properties = { 'Pack': state.pack };
    for (var i = 0; i < state.booksData.length; i++) {
      var bd = state.booksData[i];
      var p  = 'Livre ' + (i + 1) + ' - ';
      if (bd.primaryChar) {
        properties[p + 'Prénom héros']  = bd.primaryChar.prenom || '';
        properties[p + 'Âge héros']     = bd.primaryChar.age    || '';
        properties[p + 'Genre héros']   = bd.primaryChar.gender === 'girl' ? 'Fille' : 'Garçon';
        if (bd.primaryChar.reves)     properties[p + 'Rêves']     = bd.primaryChar.reves;
        if (bd.primaryChar.anecdotes) properties[p + 'Anecdotes'] = bd.primaryChar.anecdotes;
        if (bd.primaryChar.dedicace)  properties[p + 'Dédicace']  = bd.primaryChar.dedicace;
        if (bd.primaryChar.imageUrl)  properties[p + '_Image']    = bd.primaryChar.imageUrl;
      }
      if (bd.secondaryChar) {
        properties[p + 'Prénom 2ème perso'] = bd.secondaryChar.prenom || '';
        properties[p + 'Âge 2ème perso']    = bd.secondaryChar.age    || '';
        if (bd.secondaryChar.lien)     properties[p + 'Lien']     = bd.secondaryChar.lien;
        if (bd.secondaryChar.imageUrl) properties[p + '_Image 2'] = bd.secondaryChar.imageUrl;
      }
      properties[p + 'Couverture'] = bd.coverType || '';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.id) {
        window.location.href = '/cart';
      } else {
        alert('Erreur lors de l\'ajout au panier.');
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Ajouter au panier'; }
      }
    })
    .catch(function () {
      alert('Erreur réseau, veuillez réessayer.');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Ajouter au panier'; }
    });
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    injectCharPickerStep();
    preloadImages();

    // Pack cards
    document.querySelectorAll('.pb-pack-card').forEach(function (card) {
      card.addEventListener('click', function () {
        document.querySelectorAll('.pb-pack-card').forEach(function (c) { c.classList.remove('selected'); });
        this.classList.add('selected');
        state.pack = this.getAttribute('data-pb-pack');
        renderNav();
      });
    });

    // Secondary character toggle
    var secCard = document.querySelector('.secondary-choice-card');
    if (secCard) {
      secCard.onclick = function (e) {
        e.preventDefault();
        var bd = state.booksData[state.currentBookIndex];
        if (!bd) return;
        bd.hasSecondary = !bd.hasSecondary;
        var toggle   = document.getElementById('pbSecondaryToggle');
        var checkbox = document.getElementById('pbSecondaryCheckbox');
        if (toggle)   toggle.classList.toggle('active', bd.hasSecondary);
        if (checkbox) checkbox.checked = bd.hasSecondary;
      };
    }

    // Gender buttons
    document.querySelectorAll('.pb-gender-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        charState.gender   = this.getAttribute('data-pb-gender');
        charState.hairIdx  = 0;
        var validCats = getCategories(charState.gender).map(function(c){return c.id;});
        if (validCats.indexOf(charState.category) === -1) charState.category = validCats[0];
        renderCharUI();
      });
    });

    // Gender prev/next buttons
    var genderPrevBtn = document.getElementById('pbGenderPrev');
    var genderNextBtn = document.getElementById('pbGenderNext');
    var genders = ['boy', 'girl'];
    if (genderPrevBtn) genderPrevBtn.addEventListener('click', function () {
      var idx = genders.indexOf(charState.gender);
      charState.gender  = genders[(idx - 1 + genders.length) % genders.length];
      charState.hairIdx = 0;
      var validCatsPrev = getCategories(charState.gender).map(function(c){return c.id;});
      if (validCatsPrev.indexOf(charState.category) === -1) charState.category = validCatsPrev[0];
      renderCharUI();
    });
    if (genderNextBtn) genderNextBtn.addEventListener('click', function () {
      var idx = genders.indexOf(charState.gender);
      charState.gender  = genders[(idx + 1) % genders.length];
      charState.hairIdx = 0;
      var validCatsNext = getCategories(charState.gender).map(function(c){return c.id;});
      if (validCatsNext.indexOf(charState.category) === -1) charState.category = validCatsNext[0];
      renderCharUI();
    });

    // Cover cards
    document.querySelectorAll('.pb-cover-card').forEach(function (card) {
      card.addEventListener('click', function () {
        document.querySelectorAll('.pb-cover-card').forEach(function (c) { c.classList.remove('selected'); });
        this.classList.add('selected');
        var bd = state.booksData[state.currentBookIndex];
        if (bd) bd.coverType = this.getAttribute('data-pb-cover');
        renderNav();
      });
    });

    // Nav buttons
    var nextBtn   = document.getElementById('pbNextBtn');
    var prevBtn   = document.getElementById('pbPrevBtn');
    var submitBtn = document.getElementById('pbSubmitBtn');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (this.disabled) return;
      if (state.currentStep === 'pbStepChar') {
        capturePackCharacter().then(function(url) {
          charState.imageUrl = url || '';
        }).catch(function() {
          charState.imageUrl = '';
        });
      }
      nextStep();
    });
    if (prevBtn)   prevBtn.addEventListener('click', prevStep);
    if (submitBtn) submitBtn.addEventListener('click', addToCart);

    // Category prev/next arrows
    var catPrev = document.getElementById('pbCatPrev');
    var catNext = document.getElementById('pbCatNext');
    if (catPrev) catPrev.onclick = function () {
      var ids = getCategories(charState.gender).map(function (c) { return c.id; });
      var idx = ids.indexOf(charState.category);
      if (idx > 0) { charState.category = ids[idx - 1]; renderCharUI(); }
    };
    if (catNext) catNext.onclick = function () {
      var ids = getCategories(charState.gender).map(function (c) { return c.id; });
      var idx = ids.indexOf(charState.category);
      if (idx < ids.length - 1) { charState.category = ids[idx + 1]; renderCharUI(); }
    };

    // Variant prev/next arrows
    var varPrev = document.getElementById('pbVarPrev');
    var varNext = document.getElementById('pbVarNext');
    if (varPrev) varPrev.onclick = function () {
      var cur = getCatIdx();
      if (cur > 0 && !(charState.category === 'hair' && isHairBlocked(cur - 1))) { setCatIdx(cur - 1); renderCharUI(); }
    };
    if (varNext) varNext.onclick = function () {
      var cur  = getCatIdx();
      var opts = getOptions(charState.category, charState.gender);
      if (cur < opts.length - 1 && !(charState.category === 'hair' && isHairBlocked(cur + 1))) { setCatIdx(cur + 1); renderCharUI(); }
    };

    // Color prev/next arrows
    var colorPrevBtn = document.getElementById('pbColorPrev');
    var colorNextBtn = document.getElementById('pbColorNext');
    if (colorPrevBtn) colorPrevBtn.addEventListener('click', function () {
      if (charState.hairColorIdx > 0) { charState.hairColorIdx--; renderCharUI(); }
    });
    if (colorNextBtn) colorNextBtn.addEventListener('click', function () {
      if (typeof HAIR_COLORS !== 'undefined' && charState.hairColorIdx < HAIR_COLORS.length - 1) { charState.hairColorIdx++; renderCharUI(); }
    });

    // Form validation on input
    ['pbPrenom', 'pbAge'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', renderNav);
    });

    // Initial render
    renderProgressDots();
    renderNav();
  });

  // Support rechargement section dans l'éditeur Shopify
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector('#pbNextBtn')) return;
    state.pack             = null;
    state.currentBookIndex = 0;
    state.booksData        = [];
    state.currentStep      = 'pbStepPack';
    charState = createDefaultCharState();
    document.querySelectorAll('.step').forEach(function (s) { s.classList.remove('active'); });
    var packStep = document.getElementById('pbStepPack');
    if (packStep) packStep.classList.add('active');
    document.querySelectorAll('.pb-pack-card').forEach(function (c) { c.classList.remove('selected'); });
    renderProgressDots();
    renderNav();
  });

})();
